import { EntityTypes, SubscriptionStatus, SubscriptionTypes } from "./enums";

export interface SourcingAllySubscription {
    subscriptionId: string;
    userId: string;
    subscriptionToken: string;
    entityType: EntityTypes.sourcingAllySubscription;
    subscriptionTier: SubscriptionTypes;
    maximumRequests?: number;
    remainingRequests?: number;
    status: SubscriptionStatus;
    expiration: number;
    created: number;
    lastUpdated: number;
}

export interface CreateSourcingAllySubscriptionInput {
    userId: string;
    subscriptionToken: string;
    subscriptionTier: SubscriptionTypes;
    expiration: number;
}

export interface ChangeSourcingAllySubscriptionInput {
    subscriptionId: string;
    created: number;
    userId: string;
    subscriptionToken: string;
    subscriptionTier: SubscriptionTypes;
    expiration: number;
}